import React, { useRef } from 'react'
import Swiper from "react-id-swiper";
import "swiper/css/swiper.css";
import { IconChevronRight } from './Icons';
import styled from 'styled-components/macro';

type LogoCarouselProps = {
    logo: {node: {logoUrl: string, name: string} }[];
    title: string;
}

const Container = styled.div`
    height: 20rem;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    overflow: hidden;
    .swiper-container {
        margin: 0 3rem 0 3rem;
    }
    @media screen and (max-width: 768px) {
        height: 15rem;
        .swiper-container {
            margin: 0 0 0 1rem;
            z-index: 0;
        }
    }
`;

const LogoCarouselTitle = styled.div`
    font-weight: 700;
    font-size: 2.4rem;
    text-align: center;
    font-family: 'Montserrat';
    @media screen and (max-width: 768px) {
        font-size: 1.8rem;
    }
`;

const LogosContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    position: relative;
    
    @media screen and (max-width: 768px) {
        /* width: 12.8rem; */
        height: 4.3rem;
    }
`;

const Logo = styled.img`
    display: block;
    width: 20rem;
    height: 7rem;
    padding: 0px 10px;
    @media screen and (max-width: 768px) {
        max-width: 100%;
        object-fit: contain;
    }
`;

const ChevronLeft = styled.div`
    width: 3rem;
    height: 3rem;
    border: 1px solid black;
    border-radius: 100%;
    padding: 10px;
    transform: rotate(180deg);
    display: flex;
    cursor: pointer;
    svg {
        width: 1.5rem;
        height: 1.5rem;
        align-self: center;
    }
    @media screen and (max-width: 768px) {
        display: none;
    }
`;

const ChevronRight = styled.div`
    width: 3rem;
    height: 3rem;
    border: 1px solid black;
    border-radius: 100%;
    padding: 10px;
    display: flex;
    cursor: pointer;
    svg {
        width: 1.5rem;
        height: 1.5rem;
        align-self: center;
    }
    @media screen and (max-width: 768px) {
        display: none;
    }
`;

export const LogoCarousel = ({ logo, title }: LogoCarouselProps) => {

    const ref: any = useRef(null);

    const goNext = () => {
        if (ref && ref.current !== null && ref.current.swiper !== null) {
            ref.current.swiper.slideNext();
        }
    };
    
    const goPrev = () => {
        if (ref.current !== null && ref.current.swiper !== null) {
            ref.current.swiper.slidePrev();
        }
    };

    const params = {
        pagination: {
            clickable: true,
        },
        spaceBetween: 15,
        slidesPerView: 2.5,
        slidesPerGroup: 1,
        loop: true,
        breakpoints: {
            768: {
              slidesPerView: 4,
              slidesPerGroup: 4,
              spaceBetween: 30,
            }
        }
    }

    return (
        <Container>
            <LogoCarouselTitle>{title}</LogoCarouselTitle>
            <LogosContainer>
                <ChevronLeft onClick={goPrev}>
                    <IconChevronRight/>
                </ChevronLeft>
                <Swiper ref={ref} {...params}>
                    {logo.map((l, index) => (
                        <Logo key={index} src={l.node.logoUrl} alt={l.node.name} />                   
                    ))}
                </Swiper>
                <ChevronRight onClick={goNext}>
                    <IconChevronRight/>
                </ChevronRight>
            </LogosContainer>
        </Container>
    );
};